<template>
    <button class="btn-vocalize">
        <svg class="btn-vocalize__icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.3 12.8a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zm0-5.4a1.8 1.8 0 110 3.6 1.8 1.8 0 010-3.6zm-2.7 6.3H11a3.6 3.6 0 013.6 3.6v1.8a.9.9 0 11-1.8 0v-1.8a1.8 1.8 0 00-1.8-1.8H5.6a1.8 1.8 0 00-1.8 1.8v1.8a.9.9 0 11-1.8 0v-1.8a3.6 3.6 0 013.6-3.6zm10.316-4.5a5.38 5.38 0 01-1.586 3.828.9.9 0 01-1.273-1.273 3.613 3.613 0 000-5.11.9.9 0 111.273-1.273A5.38 5.38 0 0115.916 9.2zm-.163 6.93a.9.9 0 01.021-1.273 7.802 7.802 0 000-11.305.903.903 0 011.256-1.3 9.6 9.6 0 010 13.895.9.9 0 01-1.273-.022l-.004.005z" fill="gray"/></svg>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/btn-vocalize.css"></style>